export const MENU_ITEMS = [
  { title: 'Vision', href: '#hintergrund', highlight: false },
  { title: 'Features', href: '#features', highlight: true },
  { title: 'Technik', href: '#technical', highlight: false },
  { title: 'Module', href: '#modules', highlight: false },
  // { title: 'Timeline', href: '#timeline', highlight: false },
  { title: 'Wettbewerbe', href: '#awards', highlight: false },
  { title: 'Buch', href: '#book', highlight: false },
  { title: 'Opencode', href: '#opencode', highlight: false },
  { title: 'Kontakt', href: '#contact', highlight: false },
];